import {Spinner} from "reactstrap";

// État `processing` : géocodage en vol (debounce ou requête IGN).
export function AddressChecking() {
  return (
    <div style={{fontSize: "13px", color: "#888", marginBottom: "8px"}}>
      <Spinner size="sm" color="secondary" className="me-2" />
      Vérification de l'adresse…
    </div>
  );
}
